{
  "version": 1,
  "meta": {
    "id": "into-the-complex",
    "name": "Into the Complex",
    "description": "The signature level — enter the Complex plane through a portal transition",
    "author": "TriggernometryDash",
    "difficulty": "normal",
    "version": 1,
    "parTime": 70000,
    "optimalInputs": 45,
    "tags": ["transition", "complex", "showcase"]
  },
  "settings": {
    "initialMode": "real",
    "initialSpeed": 1.0,
    "initialPlayerMode": "triangle",
    "baseColor": "#ff6600",
    "accentColor": "#ffff00",
    "backgroundColor": "#0a0a1a",
    "gridIntensity": 0.7,
    "music": {
      "bpm": 128,
      "key": "Am",
      "style": "synthwave",
      "song": "pulse-grid",
      "layers": ["bass", "drums", "arp"]
    },
    "fog": { "near": 50, "far": 200, "color": "#0a0a1a" }
  },
  "segments": [
    {
      "id": "seg-01-warmup",
      "mode": "real",
      "length": 1000,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": { "function": "constant", "offset": 80 },
        "ceiling": null
      },
      "obstacles": [
        { "type": "spike", "position": { "along": 250, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 500, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 530, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "wall", "position": { "along": 750, "across": 0, "up": 0 }, "size": { "width": 30, "height": 50 } }
      ],
      "decorations": []
    },
    {
      "id": "seg-02-building",
      "mode": "real",
      "length": 1500,
      "speed": 1.1,
      "terrain": {
        "type": "function",
        "floor": { "function": "sin", "amplitude": 25, "frequency": 0.01, "offset": 80, "phase": 0 },
        "ceiling": null
      },
      "obstacles": [
        { "type": "spike", "position": { "along": 200, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 400, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 430, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 600, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "wall", "position": { "along": 800, "across": 0, "up": 0 }, "size": { "width": 25, "height": 45 } },
        { "type": "spike", "position": { "along": 1000, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 1030, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 1060, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 1300, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } }
      ],
      "decorations": []
    },
    {
      "id": "seg-03-pre-portal",
      "mode": "real",
      "length": 500,
      "speed": 1.2,
      "terrain": {
        "type": "function",
        "floor": { "function": "sin", "amplitude": 35, "frequency": 0.015, "offset": 80, "phase": 0 },
        "ceiling": null
      },
      "obstacles": [
        { "type": "spike", "position": { "along": 150, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 300, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 330, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } }
      ],
      "decorations": []
    },
    {
      "id": "seg-04-complex-tutorial",
      "mode": "complex",
      "length": 2000,
      "speed": 1.0,
      "terrain": {
        "type": "tunnel",
        "floor": null,
        "ceiling": null
      },
      "obstacles": [],
      "decorations": []
    },
    {
      "id": "seg-05-complex-challenge",
      "mode": "complex",
      "length": 2000,
      "speed": 1.1,
      "terrain": {
        "type": "tunnel",
        "floor": null,
        "ceiling": null
      },
      "obstacles": [],
      "decorations": []
    }
  ],
  "triggers": [
    {
      "id": "trg-01-intro",
      "type": "text",
      "position": 50,
      "duration": 2500,
      "easing": "sine-in-out",
      "params": { "text": "Something is changing...", "style": "floating" }
    },
    {
      "id": "trg-02-color-warm",
      "type": "color",
      "position": 1500,
      "duration": 1000,
      "easing": "sine-in-out",
      "params": { "baseColor": "#ffaa00", "accentColor": "#ffff44" }
    },
    {
      "id": "trg-03-speed-build",
      "type": "speed",
      "position": 2000,
      "duration": 500,
      "easing": "ease-in",
      "params": { "speed": 1.2 }
    },
    {
      "id": "trg-04-portal",
      "type": "mode",
      "position": 3000,
      "duration": 2000,
      "easing": "sine-in-out",
      "params": { "targetMode": "complex", "transition": "portal" }
    },
    {
      "id": "trg-05-welcome-complex",
      "type": "text",
      "position": 3200,
      "duration": 3000,
      "easing": "sine-in-out",
      "params": { "text": "Welcome to the Complex plane", "style": "floating" }
    },
    {
      "id": "trg-06-controls-hint",
      "type": "text",
      "position": 3800,
      "duration": 2500,
      "easing": "sine-in-out",
      "params": { "text": "Arrow keys: Real + Imaginary axes", "style": "floating" }
    }
  ],
  "collectibles": [
    { "type": "star", "position": { "along": 1700, "across": 0, "up": 150 }, "index": 0 },
    { "type": "star", "position": { "along": 4500, "across": 0, "up": 100 }, "index": 1 },
    { "type": "star", "position": { "along": 6200, "across": 0, "up": 130 }, "index": 2 }
  ]
}
